import axios from 'axios'

export default {
  namespaced: true,
  state: {
    open: 0,
    items: [],
    item: {},
    incaricato: {},
    itemsRUBU: []
  },

  mutations: {
    setOpen (state, value) {
      state.open = value || 0
    },
    setItems (state, value) {
      state.items = value || []
    },
    setItem (state, value) {
      state.item = value || {}
    },
    setIncaricato (state, value) {
      state.incaricato = value || {}
    },
    setItemsRUBU (state, value) {
      // console.log('setItemsRUBU', value, state)
      state.itemsRUBU = value || []
    }
  },
  actions: {
    async loadIncaricato ({ commit }, user) {
      try {
        let rs = await axios.get(`/api/abilitazioni/${user.codiceFiscale}/incaricato`)
        // console.log('/api/abilitazioni/userCf/incaricato', rs.data)
        commit('setIncaricato', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItems ({ commit }) {
      try {
        let rs = await axios.get('/api/abilitazioni')
        // console.log('/api/abilitazioni', rs.data)
        commit('setItems', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadRUBUItems ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/abilitazioni/${id}/RUBU`)
        // console.log('/api/abilitazioni/RUBU', rs.data)
        commit('setItemsRUBU', rs.data)
      } catch (err) {
        throw err
      }
    },
    async loadItemById ({ commit }, id) {
      try {
        let rs = await axios.get(`/api/abilitazioni/${id}`)
        // console.log('Abilitazioni loadItemById ', JSON.stringify(rs.data, null, 2), id)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async countOpen ({ commit }) {
      try {
        let rs = await axios.get(`/api/abilitazioni`, { params: { op: 'contaAperte' } })
        commit('setOpen', rs.data.count)
      } catch (err) {
        throw err
      }
    },

    async addNew ({ commit }, { codiceUib, codiceUtente, codiceFiscaleIncaricato, incaricato, confermaLettura, tipoDoc, idIncarico }) {
      try {
        // console.log('addNew abilitazioni', codiceUib, codiceUtente, codiceFiscaleIncaricato, incaricato, confermaLettura, tipoDoc, idIncarico)
        let rs = await axios.post(`/api/abilitazioni`, { codiceUib, codiceUtente, codiceFiscaleIncaricato, incaricato, confermaLettura, tipoDoc, idIncarico })
        commit('setItem', rs.data)
        return rs.data
      } catch (err) {
        throw err
      }
    },

    async assegnaDelega (ctx, { idDelega, utenza }) {
      try {
        // console.log('ctx', ctx)
        // console.log('Abilitazioni assegnaDelega', idDelega, utenza)
        let rs = await axios.post(`/api/abilitazioni/assegnaDelega`, { idDelega, utenza })
        // commit('setUser', rs.data)

        ctx.commit('setUser', rs.data, { root: true })
        // ctx.rootState.auth.user = rs.data

        return rs.data
      } catch (err) {
        throw err
      }
    },

    async rimuoviDelega (ctx, { user }) {
      try {
        // console.log('Abilitazioni rimuoviDelega', user)
        let rs = await axios.post(`/api/abilitazioni/rimuoviDelega`, { user })
        // commit('setItem', rs.data)  ??
        // console.log('Abilitazioni delega rimossa', rs.data)
        ctx.commit('setUser', rs.data, { root: true })

        return rs.data
      } catch (err) {
        throw err
      }
    },

    async save ({ commit }, { id, formData }) {
      try {
        // console.log('formData.abilitazioni', id, formData.get('abilitazioni'))
        let rs = await axios({ method: 'put', url: `/api/abilitazioni/${id}`, data: formData, headers: { 'Content-Type': 'multipart/form-data' } })
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async delete ({ commit }, item) {
      try {
        let rs = await axios.put(`/api/abilitazioni/${item.id}/delete`, item)
        commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },

    async allegati ({ commit }, { templateId, documentData }) {
      try {
        // console.log('Parametri per la post', templateId, documentData)
        await axios.post(`/api/abilitazioni/allegati`, { templateId, documentData }, { responseType: 'blob' }).then(function (response) {
          // console.log('Contenuto della response', response)

          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          // console.log('Nome file generato..', documentData)
          link.download = templateId + '_' + documentData.id + '.pdf'
          // link.setAttribute('download', 'file.pdf') // or any other extension
          // document.body.appendChild(link)
          link.click()
        })
        // commit('setItem', rs.data)
      } catch (err) {
        throw err
      }
    },
    async checkTitolare ({ commit }, { titolare, tipoAbilitazione }) {
      // Verifica se titolare esiste ed eventualmente crea la richiesta vuota.
      let rs = await axios.get(`/api/abilitazioni/checkTitolare`, { params: { titolare: titolare, tipoAbilitazione: tipoAbilitazione } })

      // console.log('checkTitolare result', rs.data)

      return rs.data
      // commit('setItem', rs.data)
    },

    async checkTitolareIncaricato ({ commit }, { titolare }) {
      // Verifica se titolare esiste ed eventualmente crea la richiesta vuota.
      let rs = await axios.get(`/api/abilitazioni/checkTitolareIncaricato`, { params: { titolare: titolare} })

      // console.log('checkTitolare result', rs.data)

      return rs.data
      // commit('setItem', rs.data)
    }

  }
}
